import { useEffect } from 'react';
import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { NewsContainer } from './NewsContainer';
import styles from './News.module.scss';

interface INewsProps {
  locationMainPage?: boolean;
}

export const News = ({ locationMainPage }: INewsProps) => {
  useTitle('Новости');
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <>
      {locationMainPage ? (
        <NewsContainer locationMainPage={locationMainPage} />
      ) : (
        <Layout>
          <div className={styles.NewsPage}>
            <NewsContainer />
          </div>
        </Layout>
      )}
    </>
  );
};
